import * as React from "react";
import { faTimesCircle, faCheckCircle, faHourglassStart } from "@fortawesome/free-solid-svg-icons";
import "./style.scss";
import { IconConfig } from "../GenericIcon/IconConfig";
import { BcheckResponseEnum } from "src/services/interfaces/Compliance/BcheckResponseEnum";
import { GenericIcon } from "../GenericIcon/GenericIcon";

interface IBcheckIconProps { response: string }

export const BcheckIcon: React.FC<IBcheckIconProps> = ({ response }) => {
  const BCheckIcons: IconConfig<BcheckResponseEnum> = {
    AwaitingHookResponse: {
      icon: faHourglassStart,
      label: "Aguardando Resposta",
      className: "waiting"
    },
    Approved: {
      icon: faCheckCircle,
      label: "Aprovado",
      className: "success"
    },
    Hit: {
      icon: faTimesCircle,
      label: "Reprovado",
      className: "danger"
    },
    ApprovedWithObservations: {
      icon: faCheckCircle,
      label: "Aprovado com observações",
      className: "approvedWithObservations"
    },
    ApiError: {
      icon: faTimesCircle,
      label: "Erro de API",
      className: "apiError"
    }
  }

  return response && <GenericIcon iconConfig={BCheckIcons[response]} />
}



// WEBPACK FOOTER //
// ./src/components/common/Icons/Bcheck/BcheckIcon.tsx